import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { User } from '../store/models/user';
import {
  UserCreationData,
  UserCreationDataRes,
  UserInvitationData,
} from '../store/models/users-management-state.interface';
import { Response } from '../../../interfaces/response.interface';
import { ApiUrlService } from '../../../services/api-url.service';

type usersAdapter = (response: Response<User[]>) => {
  users: User[];
  // page: number;
  // totalPages: number;
  // totalItems: number;
};

type createUserAdapter = (response: Response<UserCreationDataRes>) => {
  password: string;
  user: User;
};

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private _apiUrl = this._apiService.apiUrl;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public static usersAdapter: usersAdapter = (response) => ({
    users: response.data.map(user => ({
      id: user.id,
      name: user.name,
      created_at: user.created_at,
      last_login: user.last_login,
      status: user.status,
      role: user.role,
      email: user.email,
      change_password: user.change_password,
      org_id: user.org_id,
      password_hash: user.password_hash,
      scopes: user.scopes,
      is_online: user.is_online,
      shared_orgs: user.shared_orgs,
      enable_otp: user.enable_otp,
      org_enable_otp: user.org_enable_otp,
    })),
  });


  public static createUserAdapter: createUserAdapter = (response) => ({
    user: response.data.user,
    password: response.data.password,
  });

  public getUsers(): Observable<any> {
    const url = `${this._apiUrl}/access/users`;

    // const { username, roles } = request;

    const params = {
      // ...(username ? { username } : null),
      // ...(roles ? { role: roles } : null),
      page: 1,
      'per-page': 1000,
    };

    return this._http.get<Response<User[]>>(url, { params })
      .pipe(
        map(DataService.usersAdapter),
      );
  }

  public deleteUser(userId: string): Observable<any> {
    const url = `${this._apiUrl}/access/users/${userId}`;

    return this._http.delete(url);
  }

  public createUser(userData: UserCreationData): Observable<UserCreationDataRes> {
    const url = `${this._apiUrl}/access/users`;

    return this._http.post<Response<UserCreationDataRes>>(url, { ...userData, need_change_password: true }).pipe(
      map(DataService.createUserAdapter),
    );
  }

  public inviteUser(userData: UserInvitationData) {
    const url = `${this._apiUrl}/access/invites`;

    return this._http.post(url, userData);
  }

  public updateUser(userId: string, data: Partial<User>): Observable<void> {
    const url = `${this._apiUrl}/access/users/${userId}`;

    return this._http.put<any>(url, { ...data });
  }

  public changeUserRole(id: string, name: string, role: string): Observable<void> {
    const url = `${this._apiUrl}/access/users/${id}`;

    return this._http.put<any>(url, { role, name });
  }

  public resetPassword(userId: string, password: string): Observable<any> {
    const url = `${this._apiUrl}/access/password/${userId}`;

    return this._http.put(url, { new_password: password });
  }

  public getUserData(id: string): Observable<User> {
    const url = `${this._apiUrl}/access/users/${id}`;
    return this._http.get<Response<User>>(url)
      .pipe(
        map((response) => response.data),
      )
  }

  public reset2FA(userId: string): Observable<any> {
    const url = `${this._apiUrl}/access/users/${userId}/reset-otp`;

    return this._http.post(url, {});
  }
}
